module.exports = __webpack_public_path__ + "img/office.3b69ae0e.svg";